import React from 'react';
import { ServicesContext } from '~/services';

export function StaticBasicInfo() {
    const servicesContext = React.useContext(ServicesContext);
    const user = servicesContext.user.get();

    return (
        <>
            <div className="row">
                <div className="col-3 text-end">Full Name</div>
                <div className="col-9">
                    {user.first_name} {user.last_name}
                </div>
            </div>
            <div className="row">
                <div className="col-3 text-end">Title</div>
                <div className="col-9">{user.title}</div>
            </div>
        </>
    );
}
